<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="板块">
          <el-select v-model="query.schoolType" clearable placeholder="全部" style="width:130px" @change="onSchoolTypeChange">
            <el-option v-for="t in schoolTypes" :key="t.value" :label="t.label" :value="t.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader v-model="query.categoryId" :options="categoryOptions" :props="categoryCascaderProps"
            clearable filterable placeholder="全部分类" style="width:260px" popper-class="ai-scene-category-cascader" />
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="场景标题" clearable style="width:160px" />
        </el-form-item>
        <el-form-item label="模式">
          <el-select v-model="query.mode" clearable placeholder="全部" style="width:110px">
            <el-option :value="1" label="练习" />
            <el-option :value="2" label="考试" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.state" clearable placeholder="全部" style="width:110px">
            <el-option :value="1" label="启用" />
            <el-option :value="0" label="禁用" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-button type="primary" size="mini" icon="el-icon-magic-stick" @click="generateDialogVisible = true" v-hasPermi="['aiTrain:scene:generate']">
          AIGC 生成场景
        </el-button>
        <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['aiTrain:scene:add']">手动新建</el-button>
        <el-button size="mini" @click="$refs.roleStylePanel.open()">角色风格库</el-button>
      </div>

      <el-table v-loading="listLoading" :data="list" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="title" label="场景标题" min-width="160" show-overflow-tooltip />
        <el-table-column prop="theme" label="主题" min-width="140" show-overflow-tooltip />
        <el-table-column prop="categoryName" label="分类" width="140" show-overflow-tooltip />
        <el-table-column label="难度" width="110">
          <template slot-scope="{row}">{{ row.tierName || '-' }}（{{ row.difficultyPercent }}%）</template>
        </el-table-column>
        <el-table-column label="模式" width="80">
          <template slot-scope="{row}"><el-tag size="mini" :type="row.mode === 2 ? 'warning' : 'success'">{{ row.mode === 2 ? '考试' : '练习' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="durationMin" label="时长(分)" width="90" />
        <el-table-column prop="passScore" label="通关分" width="80" />
        <el-table-column prop="maxTurns" label="最大轮次" width="90" />
        <el-table-column label="状态" width="90">
          <template slot-scope="{row}">
            <el-switch v-model="row.stateBool" @change="handleToggleState(row)" v-hasPermi="['aiTrain:scene:edit']" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="500" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handleEdit(row)" v-hasPermi="['aiTrain:scene:edit']">编辑</el-button>
            <el-button type="text" size="mini" @click="$refs.trialPanel.open(row)" v-hasPermi="['aiTrain:scene:edit']">试聊</el-button>
            <el-button type="text" size="mini" @click="$refs.trialPanel.history(row)" v-hasPermi="['aiTrain:scene:edit']">预览记录</el-button>
            <el-button type="text" size="mini" @click="goSceneRecords(row)" v-hasPermi="['aiTrain:record:list']">正式记录</el-button>
            <el-button type="text" size="mini" @click="goScoreTemplate(row)">评分表</el-button>
            <el-button type="text" size="mini" @click="goAuth(row)">授权</el-button>
            <el-button type="text" size="mini" v-if="row.schoolType === 3" @click="handleTag(row)" v-hasPermi="['aiTrain:scene:edit']">关联范围</el-button>
            <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(row)" v-hasPermi="['aiTrain:scene:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="onPagination" />
    </el-card>

    <!-- AIGC 生成 -->
    <el-dialog title="AIGC 生成场景草稿" :visible.sync="generateDialogVisible" width="640px" :close-on-click-modal="false">
      <el-form ref="generateFormRef" :model="generateForm" :rules="generateFormRules" label-width="110px" size="small">
        <el-form-item label="场景描述 / 背景">
          <el-input v-model="generateForm.backgroundContext" type="textarea" :rows="3" placeholder="描述要训练的真实业务场景，AI 将据此补全岗位、目标、客户身份与评分建议" />
        </el-form-item>
        <el-form-item label="学员岗位"><el-input v-model="generateForm.jobPosition" placeholder="可选，如销售、客服、技术支持" /></el-form-item>
        <el-form-item label="核心训练目标"><el-input v-model="generateForm.coreTaskGoal" type="textarea" :rows="2" placeholder="可选，描述希望学员在本场景达成的目标" /></el-form-item>
        <el-form-item label="具体角色身份"><el-input v-model="generateForm.roleIdentity" placeholder="可选，AI 扮演的具体客户身份" /></el-form-item>
        <el-form-item label="客户画像" prop="descCustomerProfile">
          <el-input v-model="generateForm.descCustomerProfile" type="textarea" :rows="2" placeholder="四要素之一：客户画像" />
        </el-form-item>
        <el-form-item label="意图" prop="descIntent">
          <el-input v-model="generateForm.descIntent" type="textarea" :rows="2" placeholder="四要素之一：客户意图" />
        </el-form-item>
        <el-form-item label="个人情况" prop="descPersonal">
          <el-input v-model="generateForm.descPersonal" type="textarea" :rows="2" placeholder="四要素之一：个人情况" />
        </el-form-item>
        <el-form-item label="诉求" prop="descDemand">
          <el-input v-model="generateForm.descDemand" type="textarea" :rows="2" placeholder="四要素之一：诉求" />
        </el-form-item>
        <el-form-item label="角色类型" prop="aiRoleType">
          <el-select v-model="generateForm.aiRoleType" style="width:100%">
            <el-option :value="1" label="挑剔" />
            <el-option :value="2" label="友好" />
            <el-option :value="3" label="应付" />
          </el-select>
        </el-form-item>
        <el-form-item label="难度" prop="difficultyPercent">
          <el-slider v-model="generateForm.difficultyPercent" :min="0" :max="100" show-input style="width:100%" />
          <span class="hint">展示档位：{{ tierLabel(generateForm.difficultyPercent) }}；评分难度：{{ difficultyPreview(generateForm.difficultyPercent) }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="generateDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="generating" @click="handleGenerateSubmit">生成草稿</el-button>
      </div>
    </el-dialog>

    <!-- 编辑/新建 -->
    <el-dialog :title="wizardActive ? '新增场景' : '编辑场景'" :visible.sync="editDialogVisible" width="94%" top="4vh" custom-class="ai-scene-editor" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="beforeEditorClose">
      <el-steps v-if="wizardActive" :active="wizardStep" finish-status="success" simple class="mb10">
        <el-step title="基础配置" /><el-step title="评分标准" /><el-step title="场景权限" />
      </el-steps>
      <div v-show="!wizardActive || wizardStep === 0">
      <el-alert v-if="!form.id" title="建议先保存草稿、配置评分与受众，再通过管理端试聊核对效果，确认后从场景列表启用。" type="info" :closable="false" class="mb10" />
      <el-alert v-if="generatedDraft && generatedDraftStub" title="本次内容为模拟建议，尚未经真实 AI 生成，请人工核对完整草稿与评分标准。" type="warning" :closable="false" class="mb10" />
      <el-form ref="editFormRef" :model="form" :rules="editFormRules" label-width="110px" size="small">
        <el-form-item label="所属分类" prop="categoryId">
          <el-cascader v-model="form.categoryId" :options="categoryOptionsAll" :props="categoryCascaderProps"
            clearable filterable style="width:100%" placeholder="请选择所属板块，再逐级选择分类" popper-class="ai-scene-category-cascader" />
        </el-form-item>
        <el-form-item label="场景标题" prop="title">
          <el-input v-model="form.title" maxlength="60" show-word-limit />
        </el-form-item>
        <el-form-item label="主题" prop="theme">
          <el-input v-model="form.theme" maxlength="60" show-word-limit />
        </el-form-item>
        <el-form-item label="学员岗位"><el-input v-model="form.jobPosition" maxlength="100" placeholder="如销售、客服、技术支持" /></el-form-item>
        <el-form-item label="核心训练目标"><el-input v-model="form.coreTaskGoal" type="textarea" :rows="2" placeholder="学员应达成的业务目标，也是 AI 判断目标是否完成的依据" /></el-form-item>
        <el-form-item label="场景背景"><el-input v-model="form.backgroundContext" type="textarea" :rows="3" placeholder="描述业务背景、沟通情境和已知信息" /></el-form-item>
        <el-form-item label="具体角色身份"><el-input v-model="form.roleIdentity" maxlength="100" placeholder="AI 实际扮演的客户身份，如投诉客户、意向加盟商" /></el-form-item>
        <el-form-item label="客户画像">
          <el-input v-model="form.descCustomerProfile" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="意图">
          <el-input v-model="form.descIntent" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="个人情况">
          <el-input v-model="form.descPersonal" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="诉求">
          <el-input v-model="form.descDemand" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="角色类型" prop="aiRoleType">
          <el-select v-model="form.aiRoleType" style="width:200px" @change="onRoleTypeChange">
            <el-option :value="1" label="挑剔" />
            <el-option :value="2" label="友好" />
            <el-option :value="3" label="应付" />
          </el-select>
        </el-form-item>
        <el-form-item label="具体角色风格">
          <el-select v-model="form.aiRoleStyleId" clearable filterable style="width:100%" placeholder="可选，选择本类型的具体风格；未选择则使用类型默认风格">
            <el-option v-for="s in availableRoleStyles" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
          <span v-if="invalidRoleStyle" class="error-hint">原风格已停用或与角色类型不匹配，请重新选择或清空。</span>
          <span v-if="!roleStylesLoaded" class="hint">角色风格尚未成功加载。</span><el-button v-if="!roleStylesLoaded" type="text" @click="loadRoleStyles">重新加载风格</el-button>
        </el-form-item>
        <el-form-item label="难度" prop="difficultyPercent">
          <el-slider v-model="form.difficultyPercent" :min="0" :max="100" show-input style="width:400px" />
          <span class="hint">展示档位：{{ tierLabel(form.difficultyPercent) }}；评分难度：{{ difficultyPreview(form.difficultyPercent) }}</span>
          <el-button v-if="difficultyRulesError" type="text" size="mini" @click="loadDifficultyRules">重新加载难度规则</el-button>
        </el-form-item>
        <el-form-item label="模式" prop="mode">
          <el-radio-group v-model="form.mode">
            <el-radio :label="1">练习</el-radio>
            <el-radio :label="2">考试</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="时长(分钟)" prop="durationMin">
          <el-input-number v-model="form.durationMin" :min="1" :max="180" />
        </el-form-item>
        <el-form-item label="通关分" prop="passScore">
          <el-input-number v-model="form.passScore" :min="0" :max="100" />
        </el-form-item>
        <el-form-item label="最大轮次" prop="maxTurns">
          <el-input-number v-model="form.maxTurns" :min="1" :max="50" />
          <span class="hint">学员成功回复一次并收到 AI 完整回复，计为一轮；达到上限会自动结束对练。</span>
        </el-form-item>
        <el-form-item label="训练角色指令">
          <el-input v-model="form.systemPrompt" type="textarea" :rows="5" placeholder="设置 AI 的具体角色身份、业务背景、学员训练目标和结束条件，可编辑自动生成的内容" />
          <span class="hint">此处指令会实际用于 AI 对话，可设置需求满足、目标完成或拒绝沟通等结束条件。</span>
        </el-form-item>
        <el-form-item label="AI开场白">
          <el-input v-model="form.openingLine" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="学习素材">
          <file-upload v-model="form.prepMaterialFiles" file-txt="上传素材" :limit="5" hint-text="学员开始训练前可查看的素材，例如产品资料 PDF" />
        </el-form-item>
        <el-form-item v-if="!wizardActive" label="状态">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
          <span class="hint">开始训练前，请确认评分表有效，且受众拥有场景权限；也可继承所属分类的批量场景授权。</span>
        </el-form-item>
      </el-form>
      </div>
      <el-card v-if="suggestedScoreItems.length && (!wizardActive || wizardStep === 1)" class="mb10" shadow="never">
        <div slot="header">AI 建议基础评分表（采用前可调整）</div>
        <el-alert :title="wizardActive ? '可将 AI 建议带入下方评分配置，继续调整后随本步骤保存。未采用时保留下方现有评分标准。' : '请确认评分业务类别、满分与标准。只有勾选“采用建议评分表”才随本次场景保存；未采用时保留原有评分表。'" type="info" :closable="false" class="mb10" />
        <el-table :data="suggestedScoreItems" border size="small">
          <el-table-column label="评分项" min-width="130"><template slot-scope="{row}"><el-input v-model="row.name" size="mini" /></template></el-table-column>
          <el-table-column label="业务类别" width="170"><template slot-scope="{row}"><el-select v-model="row.categoryCode" size="mini"><el-option v-for="c in scoreCategories" :key="c.value" :label="c.label" :value="c.value" /></el-select></template></el-table-column>
          <el-table-column label="满分" width="110"><template slot-scope="{row}"><el-input-number v-model="row.maxScore" size="mini" :min="0" :max="80" controls-position="right" style="width:100%" /></template></el-table-column>
          <el-table-column label="评分标准" min-width="200"><template slot-scope="{row}"><el-input v-model="row.criteria" type="textarea" :rows="2" /></template></el-table-column>
          <el-table-column label="细化考核点 / 流程步骤" min-width="190"><template slot-scope="{row}"><el-input :value="row.subItems.join('\n')" type="textarea" :rows="2" placeholder="每行一项，流程按行顺序核对" @input="setSuggestedSubItems(row, $event)" /></template></el-table-column>
        </el-table>
        <div class="mt10"><el-button v-if="wizardActive" size="small" :disabled="wizardSaving" @click="applySuggestedScores">采用建议到下方评分配置</el-button><el-checkbox v-else v-model="adoptSuggestedScores">采用建议评分表</el-checkbox><span class="hint">基础满分合计 {{ suggestedScoreSum }} / 80；难度分由系统另算。</span></div>
      </el-card>
      <template v-if="wizardActive && form.id && wizardStep > 0">
        <el-alert :title="'当前场景：' + form.title + '。场景已保存为草稿，完成评分和权限配置后可从列表启用。'" type="info" :closable="false" class="mb10" />
        <score-template v-if="wizardStep === 1" :key="'score:' + form.id" ref="wizardPanel" :fixed-scene="form" :show-save="false" @busy-change="wizardSaving = $event" />
        <audience-authorization v-else :key="'auth:' + form.id" ref="wizardPanel" :fixed-target="{ type: 'scene', id: form.id, name: form.title }" :show-save="false" @busy-change="wizardSaving = $event" />
      </template>
      <div slot="footer">
        <el-button :disabled="saving || wizardSaving" @click="beforeEditorClose(closeEditor)">{{ wizardActive && form.id ? '退出配置' : '取消' }}</el-button>
        <el-button v-if="wizardActive && wizardStep > 0" :disabled="wizardSaving" @click="previousWizardStep">上一步</el-button>
        <el-button v-if="!wizardActive || wizardStep === 0" type="primary" :loading="saving" @click="submitEditForm">{{ wizardActive ? '保存并配置评分标准' : '保存' }}</el-button>
        <el-button v-else type="primary" :loading="wizardSaving" :disabled="!wizardPanelReady" @click="saveWizardStep">{{ wizardStep === 1 ? '保存并配置场景权限' : '保存并完成' }}</el-button>
      </div>
    </el-dialog>

    <!-- 皮科研修院关联范围 -->
    <el-dialog title="皮科研修院关联范围" :visible.sync="tagDialogVisible" width="680px" :close-on-click-modal="false">
      <el-alert title="按课程、身份等级、会议类型或会议场次关联场景，已关联名称由系统读取。" type="info" :closable="false" class="mb10" />
      <el-alert v-if="tagLoadError" title="关联范围加载失败，请重新加载后再修改，避免覆盖原配置。" type="error" :closable="false" class="mb10">
        <el-button type="text" @click="loadTags">重新加载</el-button>
      </el-alert>
      <el-alert v-if="invalidTagCount" title="存在已删除或不可用的原关联，请移除并重新选择后保存。" type="warning" :closable="false" class="mb10" />
      <el-form label-width="90px" size="small">
        <el-form-item label="关联类型">
          <el-select v-model="tagForm.tagType" style="width:100%" @change="onTagTypeChange">
            <el-option :value="1" label="课程" />
            <el-option :value="2" label="身份等级" />
            <el-option :value="3" label="会议类型" />
            <el-option :value="4" label="会议场次" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="tagForm.tagType === 4" label="会议类型">
          <el-select v-model="tagMeetingTypeId" clearable filterable remote :remote-method="searchMeetingTypeOptions" :loading="meetingTypeOptionsLoading" placeholder="输入名称选择会议类型" style="width:100%" @change="onMeetingTypeChange">
            <el-option v-for="o in meetingTypeOptions" :key="o.id" :label="o.name" :value="o.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="tagTypeLabel(tagForm.tagType)">
          <el-select v-model="tagForm.refId" filterable remote clearable :remote-method="searchTagOptions" :loading="tagOptionsLoading" placeholder="输入名称搜索并选择" style="width:100%" @visible-change="onTagOptionsVisible" @change="onTagSelectionChange">
            <el-option v-for="o in tagOptions" :key="o.id" :label="o.name" :value="o.id" />
          </el-select>
          <span v-if="tagOptionsError" class="error-hint">选项加载失败，请重新搜索或重试。</span>
          <el-button v-if="tagOptionsError" type="text" size="mini" @click="searchTagOptions('')">重新加载选项</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" :disabled="tagLoading || tagLoadError || savingTag" @click="addTag" v-hasPermi="['aiTrain:scene:edit']">添加关联</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tagList" v-loading="tagLoading" size="mini" border>
        <el-table-column label="类型" width="90">
          <template slot-scope="{row}">{{ tagTypeLabel(row.tagType) }}</template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="{row}">
            <el-tag v-if="row.refAvailable === false" type="warning" size="mini">原关联不可用，请重新选择</el-tag>
            <span v-else>{{ row.refName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="{row, $index}">
            <el-button type="text" style="color:#f56c6c" :disabled="tagLoading || tagLoadError || savingTag" @click="tagList.splice($index,1)" v-hasPermi="['aiTrain:scene:edit']">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="tagDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingTag" :disabled="tagLoading || tagLoadError || invalidTagCount > 0" @click="submitTags" v-hasPermi="['aiTrain:scene:edit']">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="场景已创建，继续完成训练配置" :visible.sync="savedSceneGuideVisible" width="580px" :close-on-click-modal="false">
      <p>场景“{{ savedSceneGuide.title }}”已保存。评分表和实际受众范围在对应页面单独管理，请通过下方入口确认。</p>
      <el-alert title="评分表决定考核标准，场景权限决定哪些学员能访问和训练。分类的批量场景授权可继承，分类导航不受权限影响。" type="info" :closable="false" />
      <div class="mt10">
        <el-button type="primary" plain @click="openSavedSceneConfig('score')">查看 / 配置评分表</el-button>
        <el-button type="primary" plain @click="openSavedSceneConfig('auth')">查看 / 配置场景权限</el-button>
      </div>
      <div slot="footer">
        <el-button @click="savedSceneGuideVisible = false">完成</el-button>
      </div>
    </el-dialog>

    <admin-trial-panel ref="trialPanel" @configure-score="goScoreTemplate" />
    <role-style-panel ref="roleStylePanel" @changed="loadRoleStyles" />
    <scene-configuration-dialog ref="configurationDialog" />
  </div>
</template>

<script>
import { listRows, treeRows } from '@/utils/ai-train-data'
import { materialFiles, materialUrls } from '@/utils/ai-train-materials'
import aiTrainSceneApi from '@/api/aiTrain/scene'
import aiTrainCategoryApi from '@/api/aiTrain/category'
import aiTrainTierApi from '@/api/aiTrain/tier'
import aiTrainRoleStyleApi from '@/api/aiTrain/roleStyle'
import Pagination from '@/components/Pagination'
import FileUpload from '@/components/FileUpload'
import RoleStylePanel from './RoleStylePanel'
import AdminTrialPanel from './AdminTrialPanel'
import SceneConfigurationDialog from './SceneConfigurationDialog'
import ScoreTemplate from '../scoreTemplate/index'
import AudienceAuthorization from '../common/AudienceAuthorization'

const TAG_OPTION_TYPES = { 1: 'course', 2: 'identity', 3: 'meetingType', 4: 'meeting' }

export default {
  name: 'AiTrainScene',
  components: { Pagination, FileUpload, RoleStylePanel, AdminTrialPanel, SceneConfigurationDialog, ScoreTemplate, AudienceAuthorization },
  data() {
    return {
      schoolTypes: [
        { value: 1, label: '公司军校' },
        { value: 2, label: '部门军校' },
        { value: 3, label: '皮科研修院' }
      ],
      query: { schoolType: undefined, categoryId: undefined, title: undefined, mode: undefined, state: undefined, pageNo: 1, pageSize: 10 },
      list: [],
      total: 0,
      listLoading: false,
      categoryOptions: [],
      categoryOptionsAll: [],
      categoryCascaderProps: { value: 'id', label: 'name', children: 'children', emitPath: false, checkStrictly: true, multiple: false, expandTrigger: 'click' },
      difficultyTiers: [],
      difficultyRules: [],
      difficultyRulesError: false,
      roleStyles: [],
      roleStylesLoaded: false,
      generatedDraft: false,
      generatedDraftStub: false,
      suggestedScoreItems: [],
      adoptSuggestedScores: false,
      scoreCategories: [
        { value: 'material', label: '物资准备' }, { value: 'confidence', label: '气场自信 / 表达能力' },
        { value: 'tool', label: '工具使用' }, { value: 'content', label: '内容 / 重点考核' },
        { value: 'process', label: '流程 / 标准流程' }, { value: 'other', label: '其他（待确认）' }
      ],
      generateDialogVisible: false,
      generating: false,
      generateForm: this.emptyGenerateForm(),
      generateFormRules: {
        aiRoleType: [{ required: true, message: '请选择角色类型', trigger: 'change' }]
      },
      editDialogVisible: false,
      saving: false,
      wizardActive: false,
      wizardStep: 0,
      wizardSaving: false,
      editorInitialKey: '',
      savedSceneGuideVisible: false,
      savedSceneGuide: { id: null, title: '' },
      form: this.emptyForm(),
      editFormRules: {
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        title: [{ required: true, message: '请输入场景标题', trigger: 'blur' }],
        mode: [{ required: true, message: '请选择模式', trigger: 'change' }]
      },
      tagDialogVisible: false,
      savingTag: false,
      currentTagSceneId: null,
      tagForm: { tagType: 1, refId: null, refName: '' },
      tagList: [],
      tagLoading: false,
      tagLoadError: false,
      tagLoadSequence: 0,
      tagOptions: [],
      tagOptionsLoading: false,
      tagOptionsError: false,
      tagOptionSequence: 0,
      selectedTagOption: null,
      tagMeetingTypeId: null,
      meetingTypeOptions: [],
      meetingTypeOptionsLoading: false,
      meetingTypeOptionSequence: 0
    }
  },
  computed: {
    wizardPanelReady() {
      return !this.wizardSaving && !!this.form.id
    },
    availableRoleStyles() {
      return this.roleStyles.filter(s => s.state === 1 && s.roleType === this.form.aiRoleType)
    },
    invalidRoleStyle() {
      return this.form.aiRoleStyleId != null && this.roleStylesLoaded && !this.availableRoleStyles.some(s => s.id === this.form.aiRoleStyleId)
    },
    suggestedScoreSum() { return this.suggestedScoreItems.reduce((sum, s) => sum + (Number(s.maxScore) || 0), 0) },
    invalidTagCount() {
      return this.tagList.filter(t => t.refAvailable === false).length
    }
  },
  created() {
    this.loadCategoryOptions()
    this.loadDifficultyTiers()
    this.loadDifficultyRules()
    this.loadRoleStyles()
    this.loadList()
    this.openRequestedConfiguration()
  },
  watch: { '$route.query': 'openRequestedConfiguration' },
  methods: {
    openRequestedConfiguration() {
      const query = this.$route.query || {}
      if (query.configurationNotice === 'category') this.$message.warning('分类批量授权已移入场景的“授权”弹窗，请选择该分类中的场景后切换到“所属分类下场景（批量）”。')
      if (!['score', 'auth'].includes(query.configure)) return
      const id = Number(query.sceneId)
      if (!Number.isSafeInteger(id) || id <= 0) return
      this.$nextTick(() => this.$refs.configurationDialog && this.$refs.configurationDialog.open({ id }, query.configure))
    },
    onPagination({ pageNo, pageSize }) {
      this.query.pageNo = pageSize === this.query.pageSize ? pageNo : 1
      this.query.pageSize = pageSize
      this.loadList()
    },
    emptyGenerateForm() {
      return { backgroundContext: '', jobPosition: '', coreTaskGoal: '', roleIdentity: '', descCustomerProfile: '', descIntent: '', descPersonal: '', descDemand: '', aiRoleType: 1, difficultyPercent: 50 }
    },
    emptyForm() {
      return {
        id: null, categoryId: null, title: '', theme: '',
        descCustomerProfile: '', descIntent: '', descPersonal: '', descDemand: '',
        jobPosition: '', coreTaskGoal: '', backgroundContext: '', roleIdentity: '', aiRoleStyleId: null,
        aiRoleType: 1, difficultyPercent: 50,
        mode: 1, durationMin: 15, passScore: 80, maxTurns: 12,
        systemPrompt: '', openingLine: '', prepMaterialFiles: [], state: 0
      }
    },
    difficultyLabel(level) {
      return { 1: '初级', 2: '中级', 3: '高级' }[level] || '-'
    },
    tierLabel(percent) {
      const tier = this.difficultyTiers.find(t => percent >= t.percentFrom && percent <= t.percentTo)
      return tier ? tier.displayName : '-'
    },
    loadDifficultyTiers() {
      return aiTrainTierApi.fetchList().then(res => {
        const data = (res && res.data) || res || []
        this.difficultyTiers = listRows(data)
      }).catch(() => { this.difficultyTiers = [] })
    },
    difficultyPreview(percent) {
      const rule = this.difficultyRules.find(r => percent >= r.percentFrom && percent <= r.percentTo)
      if (rule) return this.difficultyLabel(rule.difficultyLevel) + '（自动计 ' + rule.difficultyScore + ' 分）'
      return this.difficultyRulesError ? '规则暂不可用，保存时由系统确定' : '规则加载中，保存时由系统确定'
    },
    loadDifficultyRules() {
      this.difficultyRulesError = false
      return aiTrainSceneApi.fetchDifficultyRules().then(res => {
        const rules = listRows((res && res.data) || res || [])
        if (!rules.length || rules.some(r => [r.percentFrom, r.percentTo, r.difficultyLevel, r.difficultyScore].some(v => typeof v !== 'number'))) {
          throw new Error('评分难度规则不可用')
        }
        this.difficultyRules = rules
      }).catch(() => { this.difficultyRules = []; this.difficultyRulesError = true })
    },
    categoryTreeOptions(tree) {
      return (tree || []).map(node => {
        const option = { id: node.id, name: node.name }
        if (node.children && node.children.length) option.children = this.categoryTreeOptions(node.children)
        return option
      })
    },
    loadCategoryOptions() {
      const loaders = [1, 2, 3].map(t => aiTrainCategoryApi.fetchTree(t).then(res => treeRows((res && res.data) || res)).catch(() => []))
      Promise.all(loaders).then(results => {
        this.categoryOptionsAll = this.schoolTypes.map((school, index) => ({
          id: 'school:' + school.value, name: school.label, schoolType: school.value, disabled: true,
          children: this.categoryTreeOptions(results[index])
        }))
        this.onSchoolTypeChange()
      })
    },
    onSchoolTypeChange() {
      this.categoryOptions = this.query.schoolType
        ? this.categoryOptionsAll.filter(c => c.schoolType === this.query.schoolType)
        : this.categoryOptionsAll
    },
    handleQuery() {
      this.query.pageNo = 1
      this.loadList()
    },
    handleReset() {
      this.query = { schoolType: undefined, categoryId: undefined, title: undefined, mode: undefined, state: undefined, pageNo: 1, pageSize: 10 }
      this.onSchoolTypeChange()
      this.loadList()
    },
    loadList() {
      this.listLoading = true
      aiTrainSceneApi.fetchList(this.query)
        .then(res => {
          const data = (res && res.data) || res || {}
          const rows = listRows(data)
          this.list = rows.map(r => ({ ...r, stateBool: r.state === 1 }))
          this.total = data.total || this.list.length
        })
        .catch(() => { this.list = []; this.total = 0 })
        .finally(() => { this.listLoading = false })
    },
    handleGenerateSubmit() {
      this.$refs.generateFormRef.validate(valid => {
        if (!valid) return
        if (![this.generateForm.backgroundContext, this.generateForm.descCustomerProfile, this.generateForm.descDemand].some(v => v && v.trim())) {
          this.$message.warning('请填写场景描述、客户画像或问题诉求后生成')
          return
        }
        this.generating = true
        aiTrainSceneApi.generate(this.generateForm)
          .then(res => {
            const draft = (res && res.data) || res || {}
            this.form = { ...this.emptyForm(), ...this.generateForm, ...draft, state: 0 }
            this.generatedDraft = true
            this.generatedDraftStub = draft.stub === true
            this.suggestedScoreItems = Array.isArray(draft.suggestedScoreItems) ? draft.suggestedScoreItems.filter(s => s && typeof s === 'object').map((s, index) => ({ ...s, name: typeof s.name === 'string' ? s.name : '', criteria: typeof s.criteria === 'string' ? s.criteria : '', categoryCode: this.scoreCategories.some(c => c.value === s.categoryCode) ? s.categoryCode : 'other', groupType: 1, subItems: Array.isArray(s.subItems) ? s.subItems.filter(v => typeof v === 'string') : [], sort: index })) : []
            this.adoptSuggestedScores = false
            this.generateDialogVisible = false
            this.wizardActive = true
            this.wizardStep = 0
            this.wizardSaving = false
            this.editorInitialKey = JSON.stringify(this.form)
            this.editDialogVisible = true
            this.$message.success('完整场景草稿已生成，先确认基础配置，第二步可采用 AI 建议评分表')
            this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate())
          })
          .catch(() => {}).finally(() => { this.generating = false })
      })
    },
    handleCreate() {
      this.form = this.emptyForm()
      this.generatedDraft = false
      this.generatedDraftStub = false
      this.suggestedScoreItems = []; this.adoptSuggestedScores = false
      if (this.query.categoryId) this.form.categoryId = this.query.categoryId
      this.wizardActive = true
      this.wizardStep = 0
      this.wizardSaving = false
      this.editorInitialKey = JSON.stringify(this.form)
      this.editDialogVisible = true
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate())
    },
    handleEdit(row) {
      aiTrainSceneApi.fetchById(row.id).then(res => {
        const detail = (res && res.data) || res || row
        this.form = { ...this.emptyForm(), ...detail, prepMaterialFiles: materialFiles(detail.prepMaterialUrls) }
        this.generatedDraft = false
        this.generatedDraftStub = false
        this.suggestedScoreItems = []; this.adoptSuggestedScores = false
        this.wizardActive = false
        this.editorInitialKey = JSON.stringify(this.form)
        this.editDialogVisible = true
        this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate())
      }).catch(e => { this.$message.error(e.message || '场景读取失败，请重新打开') })
    },
    submitEditForm() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        if (this.form.aiRoleStyleId != null && (!this.roleStylesLoaded || this.invalidRoleStyle)) { this.$message.warning('请核对并重新选择有效的具体角色风格'); return }
        if (this.adoptSuggestedScores && (!this.suggestedScoreItems.length || this.suggestedScoreSum <= 0 || this.suggestedScoreSum > 80 || this.suggestedScoreItems.some(s => !s.name || !s.name.trim() || !s.criteria || !s.criteria.trim() || !Number.isInteger(s.maxScore) || s.maxScore <= 0))) {
          this.$message.warning('采用前请确认评分项名称、标准及基础满分合计（大于0且不超过80）')
          return
        }
        // 等级由服务端从百分比派生，旧场景返回的等级不作为写入依据。
        const payload = { ...this.form }
        delete payload.knowledgeIds
        try { payload.prepMaterialUrls = materialUrls(this.form.prepMaterialFiles) }
        catch (e) { this.$message.warning(e.message); return }
        delete payload.prepMaterialFiles
        delete payload.difficultyLevel
        delete payload.suggestedScoreItems
        if (this.adoptSuggestedScores && !this.wizardActive) payload.scoreItems = this.suggestedScoreItems.map(s => ({ groupType: 1, categoryCode: s.categoryCode, name: s.name.trim(), maxScore: s.maxScore, criteria: s.criteria.trim(), subItems: s.subItems.slice(), sort: s.sort }))
        else delete payload.scoreItems
        this.saving = true
        const isNew = !payload.id
        if (this.wizardActive) payload.state = 0
        const api = this.form.id ? aiTrainSceneApi.update(payload) : aiTrainSceneApi.create(payload)
        api.then(res => {
          this.loadList()
          const sceneId = isNew ? Number(res && res.data) : payload.id
          if (this.wizardActive && Number.isSafeInteger(sceneId) && sceneId > 0) {
            this.form.id = sceneId
            if (isNew) this.form.state = 0
            this.savedSceneGuide = { id: sceneId, title: payload.title }
            this.editorInitialKey = JSON.stringify(this.form)
            this.adoptSuggestedScores = false
            this.wizardStep = 1
            this.$message.success('基础配置已保存，继续配置此场景评分标准')
          } else if (isNew && Number.isSafeInteger(sceneId) && sceneId > 0) {
            this.editDialogVisible = false
            this.savedSceneGuide = { id: sceneId, title: payload.title }
            this.savedSceneGuideVisible = true
            this.$message.success('场景已创建，可继续确认评分表和受众范围')
          } else if (isNew) {
            this.$message.error('场景创建结果未确认，请先关闭并刷新列表核对，避免重复创建')
            this.editDialogVisible = false
          } else {
            this.editDialogVisible = false
            this.$message.success('基础配置已更新，可在场景列表配置评分表和授权')
          }
        }).catch(() => {}).finally(() => { this.saving = false })
      })
    },
    handleToggleState(row) {
      const next = row.stateBool ? 1 : 0
      aiTrainSceneApi.setState(row.id, next).then(() => {
        this.$message.success('操作成功')
        row.state = next
      }).catch(() => { row.stateBool = !row.stateBool })
    },
    handleDelete(row) {
      this.$common.confirm('是否确认删除该场景？').then(() => aiTrainSceneApi.deleteById(row.id))
        .then(() => {
          this.$message.success('删除成功')
          this.loadList()
        })
    },
    goScoreTemplate(row) {
      this.$refs.configurationDialog.open(row, 'score')
    },
    goAuth(row) {
      this.$refs.configurationDialog.open(row, 'auth')
    },
    closeEditor() { this.editDialogVisible = false },
    applySuggestedScores() {
      const panel = this.$refs.wizardPanel
      if (this.wizardStep !== 1 || !panel || panel.loading || panel.loadError || panel.saving || !panel.canEdit) return
      panel.baseItems = this.suggestedScoreItems.map((item, index) => ({ ...item, id: null, groupType: 1, subItems: item.subItems.slice(), sort: index }))
      this.$message.success('已带入下方评分配置，确认后保存本步骤')
    },
    beforeEditorClose(done) {
      if (this.saving || this.wizardSaving) { this.$message.warning('正在保存，请稍候'); return }
      const panel = this.$refs.wizardPanel
      const dirty = this.wizardStep > 0 && this.wizardActive ? panel && panel.isDirty : JSON.stringify(this.form) !== this.editorInitialKey
      if (dirty) return this.$common.confirm('当前步骤的修改尚未保存，是否放弃本步修改并退出？已保存的草稿会保留。').then(done).catch(() => {})
      done()
    },
    previousWizardStep() {
      const panel = this.$refs.wizardPanel
      if (this.wizardSaving) return
      const move = () => { this.wizardStep -= 1 }
      if (panel && panel.isDirty) return this.$common.confirm('当前步骤的修改尚未保存，是否放弃本步修改并返回上一步？').then(move).catch(() => {})
      move()
    },
    async saveWizardStep() {
      const panel = this.$refs.wizardPanel
      if (this.wizardSaving || !panel || this.wizardStep === 0) return
      const step = this.wizardStep
      const saved = await panel.handleSave()
      if (!saved || step !== this.wizardStep) return
      if (step === 1) this.wizardStep = 2
      else {
        this.editDialogVisible = false
        this.loadList()
        this.$message.success('场景基础配置、评分标准和权限已保存，可从列表启用')
      }
    },
    goSceneRecords(row) {
      this.$router.push('/aiTrain/record?sceneId=' + row.id + '&sceneTitle=' + encodeURIComponent(row.title))
    },
    loadRoleStyles() {
      this.roleStylesLoaded = false
      return aiTrainRoleStyleApi.fetchList({}).then(res => { this.roleStyles = listRows(res.data); this.roleStylesLoaded = true })
        .catch(() => { this.roleStyles = []; this.roleStylesLoaded = false })
    },
    onRoleTypeChange() {
      if (this.form.aiRoleStyleId != null && !this.availableRoleStyles.some(s => s.id === this.form.aiRoleStyleId)) this.form.aiRoleStyleId = null
    },
    setSuggestedSubItems(row, text) {
      row.subItems = text.split('\n').map(s => s.trim()).filter(Boolean)
    },
    openSavedSceneConfig(type) {
      if (!this.savedSceneGuide.id) return
      this.savedSceneGuideVisible = false
      if (type === 'score') this.goScoreTemplate(this.savedSceneGuide)
      else this.goAuth(this.savedSceneGuide)
    },
    handleTag(row) {
      this.currentTagSceneId = row.id
      this.tagForm = { tagType: 1, refId: null, refName: '' }
      this.tagList = []
      this.selectedTagOption = null
      this.tagMeetingTypeId = null
      this.tagDialogVisible = true
      this.loadTags()
      this.searchTagOptions('')
      this.searchMeetingTypeOptions('')
    },
    loadTags() {
      const sceneId = this.currentTagSceneId
      const sequence = ++this.tagLoadSequence
      this.tagLoading = true
      this.tagLoadError = false
      return aiTrainSceneApi.fetchTags(sceneId).then(res => {
        if (sequence !== this.tagLoadSequence) return
        this.tagList = listRows((res && res.data) || res || [])
      }).catch(() => {
        if (sequence === this.tagLoadSequence) this.tagLoadError = true
      }).finally(() => { if (sequence === this.tagLoadSequence) this.tagLoading = false })
    },
    tagTypeLabel(type) {
      return { 1: '课程', 2: '身份等级', 3: '会议类型', 4: '会议场次' }[type] || '-'
    },
    onTagTypeChange() {
      this.tagForm.refId = null
      this.tagForm.refName = ''
      this.selectedTagOption = null
      this.tagMeetingTypeId = null
      this.tagOptions = []
      this.searchTagOptions('')
    },
    onMeetingTypeChange() {
      this.tagForm.refId = null
      this.selectedTagOption = null
      this.tagOptions = []
      this.searchTagOptions('')
    },
    onTagOptionsVisible(visible) {
      if (visible && !this.tagOptions.length) this.searchTagOptions('')
    },
    onTagSelectionChange(id) {
      this.selectedTagOption = this.tagOptions.find(o => o.id === id) || null
    },
    searchTagOptions(keyword) {
      const sequence = ++this.tagOptionSequence
      this.tagOptionsLoading = true
      this.tagOptionsError = false
      const params = { type: TAG_OPTION_TYPES[this.tagForm.tagType], keyword: (keyword || '').trim() }
      if (this.tagForm.tagType === 4 && this.tagMeetingTypeId) params.meetingTypeId = this.tagMeetingTypeId
      return aiTrainSceneApi.fetchBusinessOptions(params).then(res => {
        if (sequence !== this.tagOptionSequence) return
        this.tagOptions = listRows((res && res.data) || res || [])
      }).catch(() => {
        if (sequence === this.tagOptionSequence) { this.tagOptions = []; this.tagOptionsError = true }
      }).finally(() => { if (sequence === this.tagOptionSequence) this.tagOptionsLoading = false })
    },
    searchMeetingTypeOptions(keyword) {
      const sequence = ++this.meetingTypeOptionSequence
      this.meetingTypeOptionsLoading = true
      return aiTrainSceneApi.fetchBusinessOptions({ type: 'meetingType', keyword: (keyword || '').trim() }).then(res => {
        if (sequence === this.meetingTypeOptionSequence) this.meetingTypeOptions = listRows((res && res.data) || res || [])
      }).catch(() => {
        if (sequence === this.meetingTypeOptionSequence) this.meetingTypeOptions = []
      }).finally(() => { if (sequence === this.meetingTypeOptionSequence) this.meetingTypeOptionsLoading = false })
    },
    addTag() {
      if (this.tagLoading || this.tagLoadError || this.savingTag) return
      const option = this.selectedTagOption
      if (!option || option.id !== this.tagForm.refId) {
        this.$message.warning('请搜索并选择' + this.tagTypeLabel(this.tagForm.tagType))
        return
      }
      if (this.tagList.some(t => Number(t.tagType) === this.tagForm.tagType && String(t.refId) === String(option.id))) {
        this.$message.warning('该关联已添加')
        return
      }
      this.tagList.push({ tagType: this.tagForm.tagType, refId: option.id, refName: option.name })
      this.tagForm.refId = null
      this.selectedTagOption = null
    },
    submitTags() {
      if (this.tagLoading || this.tagLoadError || this.savingTag) return
      if (this.invalidTagCount) {
        this.$message.warning('请移除不可用的原关联并重新选择后保存')
        return
      }
      this.savingTag = true
      const tags = this.tagList.map(t => ({ tagType: t.tagType, refId: t.refId, refName: t.refName }))
      aiTrainSceneApi.saveTags(this.currentTagSceneId, tags)
        .then(() => {
          this.$message.success('保存成功')
          this.tagDialogVisible = false
        })
        .catch(() => {}).finally(() => { this.savingTag = false })
    }
  }
}
</script>

<style scoped>
.mb10 { margin-bottom: 10px; }
.mt10 { margin-top: 10px; }
.hint { display: block; color: #909399; font-size: 12px; }
.error-hint { color: #f56c6c; font-size: 12px; }
</style>
<style>
.ai-scene-editor { max-width: 1200px; }
.ai-scene-category-cascader .el-cascader-menu { min-width: 180px; }
.ai-scene-category-cascader .el-cascader-panel { max-width: calc(100vw - 40px); overflow-x: auto; }
.ai-scene-category-cascader .el-cascader-menu:first-child .el-radio { display: none; }
</style>
